module.exports = {"pieces":"pcs","hours":"hours","days":"days"};